import { render, staticRenderFns } from "./DisasterTable.vue?vue&type=template&id=df033098&scoped=true&"
import script from "./DisasterTable.vue?vue&type=script&lang=js&"
export * from "./DisasterTable.vue?vue&type=script&lang=js&"
import style0 from "./DisasterTable.vue?vue&type=style&index=0&id=df033098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df033098",
  null
  
)

export default component.exports